import {
  IAppealDecision,
  IAppealResolveParams,
  IAppealSetParams,
} from "~/entity/Appeals/model/schema";
import { IAppealSendForm } from "~/widgets/Modals/AddAppeal/model/schema";

export function toServerAppeal(
  data: IAppealSendForm,
  currentId: string,
  fileIdsOld: string[],
  scope: "appeal",
): IAppealSetParams;
export function toServerAppeal(
  data: IAppealSendForm,
  currentId: string,
  fileIdsOld: string[],
  scope: "resolution",
): IAppealResolveParams;
export function toServerAppeal(
  data: IAppealSendForm & { submitType?: "draft" | "sent" },
  currentId: string,
  fileIdsOld: string[],
  scope: "appeal" | "resolution",
): IAppealSetParams | IAppealResolveParams {
  const { submitType, ...forRequest } = data;
  const base = { ...forRequest, id: currentId, scope };

  return scope === "resolution"
    ? ({
        ...base,
        fileIdsOld,
        status: data.status.value ? "accepted" : "rejected",
      } as IAppealResolveParams)
    : ({
        ...base,
        fileIdsOld,
        contactPersonId: String(forRequest.contactPersonId.value),
      } as IAppealSetParams);
}
export function toServerAppealDecision(
  data: IAppealSendForm,
  id: number,
): IAppealDecision {
  const { fileIds, comment, status } = data;
  return {
    id,
    fileIds: fileIds.map(Number),
    resolutionComment: comment,
    malusStatus: !status.value, // TODO: Возможно тут меняется малус при изменении решения сам собой
  };
}
